/*       */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button, CircularProgress } from '@mic3/platform-ui';
import FormGenerator from 'app/containers/Designer/Form/components/FormGenerator';
import ModalDialog from 'app/components/organisms/ModalDialog/ModalDialog';
import { bind } from 'app/utils/decorators/decoratorUtils';
import { addEventDataAttribute, loadEventDataAttributes } from 'store/actions/stream/eventsActions';

export const fieldTypesOptions = [
    { label: 'Text', value: 'none', icon: 'card-text-outline' },
    { label: 'Number', value: 'number', icon: 'numeric' },
    { label: 'True or False', value: 'boolean', icon: 'checkbox-marked' },
    { label: 'Link', value: 'link', icon: 'link' },
    { label: 'Date', value: 'date', icon: 'calendar-blank' },
    { label: 'JSON', value: 'json', icon: 'view-comfy' },
];

const formDefinitions = [
    {
        type: 'typeahead',
        properties: {
            label: 'Type',
            name: 'format',
            valueField: 'format',
            options: fieldTypesOptions,
            clearable: false,
        },
        constraints: { required: true },
    },
    {
        type: 'text',
        properties: { label: 'Label', name: 'label' },
        constraints: { required: true },
    },
    {
        type: 'text',
        properties: {
            label: 'Value',
            name: 'attribute',
            valueField: 'attribute',
        },
        constraints: { required: true },
    },
];
class AddEventTypeAttribute extends PureComponent {
    static propTypes = {
        addEventType: PropTypes.func.isRequired,
    };

    formRef = React.createRef();
    constructor(props){
        super(props)
        this.state = {
            isLoading: false,
            formData: props?.selectedAttribute || {},
        }

    }

    @bind
    getAttributeTypeByFormat(format){
        switch(format){
            case 'number':
            case 'boolean':
                return format;
            default:
                return 'text'
        }
    }

    @bind
    normalizeAttributeFormat(format){
        switch(format){
            case 'number':
            case 'boolean':
                return 'none';
            default:
                return format;
        }
    }

    @bind
    normalizeEventAttributeData(data) {
        const { eventTypeId, selectedAttribute } = this.props;
        let record = { ...data };
        if (selectedAttribute?.id) {
            record.id = selectedAttribute.id;
        } else {
            record = { 
                ...record,
                eventType: eventTypeId,
                type: this.getAttributeTypeByFormat(data.format),
                format: this.normalizeAttributeFormat(data.format),
            };
        }
        return record;
    }

    @bind
    onFormSubmit(event) {
        event.preventDefault();
        const { eventTypeId, loadEventDataAttributes, addEventDataAttribute, onClose } = this.props;
        const filterBy = {
            field: 'eventType',
            op: '=',
            value: eventTypeId
        };
        this.formRef.current.isValidForm().then(({ data, errors }) => {
            if (!errors) {
                const normalizedData = this.normalizeEventAttributeData(data);
                this.setState({ isLoading: true });
                addEventDataAttribute(normalizedData).then(result => {
                    this.setState({ isLoading: false });
                    if (!(result instanceof Error) && result.id) {
                        loadEventDataAttributes({ filterBy })
                        onClose && onClose();
                    }
                });
            }
        });
    }

    @bind
    onClose() {
        const { onClose } = this.props;
        if (onClose) {
            this.props.onClose();
        }
    }
    
    @bind
    handleFormChange(formData){
        this.setState({ formData });
    }

    render() {
        const { onClose, selectedAttribute } = this.props;
        const { isLoading, formData  } = this.state;
        return (
            <>
                <ModalDialog
                    title={`${selectedAttribute?.attribute ? `Edit` : `Add`} Attribute`}
                    onClose={onClose}
                    actions={isLoading ? <CircularProgress size={24} color="primary" /> : <Button onClick={this.onFormSubmit}>Save</Button>}
                >
                    <FormGenerator
                        components={formDefinitions}
                        ref={this.formRef}
                        data={formData}
                        onChange={this.handleFormChange}
                    />
                </ModalDialog>
            </>
        );
    }
}

export default connect(null, {
    addEventDataAttribute,
    loadEventDataAttributes,
})(AddEventTypeAttribute);
